import { useState } from "react";

import { DocumentService } from "models/wizard/WizardState";
import CustomerServiceSummary from "./CustomerServiceSummary";
import CustomerServiceEdit from "./CustomerServiceEdit";

type Props = {
  fpConfig: any;
  onSetFpService: (customerChoice: string) => void;
  services: DocumentService[];
  collapsed: boolean;
  onToggleChildServices: (ids: string[], enabled: boolean) => void;
  disableFp?: boolean;
};

export default function CustomerService({
  fpConfig,
  onSetFpService,
  services,
  collapsed,
  onToggleChildServices,
  disableFp,
}: Props) {
  const [visible, setVisible] = useState(collapsed ? "summary" : "edit");

  const handleEditClick = () => {
    setVisible("edit");
  };

  const handleSaveClick = () => {
    setVisible("summary");
  };

  let visibleModule;
  if (visible === "summary") {
    visibleModule = (
      <CustomerServiceSummary
        onEditClick={handleEditClick}
        services={services}
      />
    );
  } else {
    visibleModule = (
      <CustomerServiceEdit
        onToggleChildServices={onToggleChildServices}
        showSaveButton={collapsed}
        onSaveClick={handleSaveClick}
        fpConfig={fpConfig}
        onSetFpService={onSetFpService}
        disableFp={disableFp}
      />
    );
  }

  return <div>{visibleModule}</div>;
}
